<!--
frontend-author:udayasankar,
backend-author: ,
page-name :Sales by Salesperson.vue,
page-description :Sales by Salesperson for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Salesperson-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>
          <b-dropdown-item v-b-modal.salesperson>General</b-dropdown-item>

          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown
          dropdown
          variant="light"
          size="sm"
          class="no-caret-dropdown float-right mr-2"
          
        >
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Sales by sales person
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">Sales by SalesPerson</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr style="border-top:1px solid #ededed !important">
                  <th style="background-color:#fff !important"></th>
                  <th
                    style="background-color:#fff !important"
                    colspan="3"
                    class="text-center"
                  >Invoice</th>
                  <th
                    style="background-color:#fff !important"
                    colspan="3"
                    class="text-center"
                  >Credit Note</th>
                  <th style="background-color:#fff !important" colspan="2" class="text-center">Total</th>
                </tr>
                <tr>
                  <th style="width: 180px !important;">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'sales_person_name',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      SALES PERSON
                      <small class="text-muted" v-if="label == 'sales_person_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'inv_count_id',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      COUNT
                      <small class="text-muted" v-if="label == 'inv_count_id'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'inv_amt_without_tax',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITHOUT TAX
                      <small class="text-muted" v-if="label == 'inv_amt_without_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'inv_amt_with_tax',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITH TAX
                      <small class="text-muted" v-if="label == 'inv_amt_with_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'crdt_count_id',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      COUNT
                      <small class="text-muted" v-if="label == 'crdt_count_id'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'crdt_amt_without_tax',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITHOUT TAX
                      <small class="text-muted" v-if="label == 'crdt_amt_without_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'crdt_amt_with_tax',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITH TAX
                      <small class="text-muted" v-if="label == 'crdt_amt_with_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'without_total_balance',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITHOUT TAX
                      <small class="text-muted" v-if="label == 'without_total_balance'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 140px !important;" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesPerson',query: {sort:sort == 'asc' ? 'desc' : 'asc',label:'total_balance',sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count } }"
                    >
                      WITH TAX
                      <small class="text-muted" v-if="label == 'total_balance'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="9" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item,index) in lists" :key="index" @click="oldRoute = $route.query">
                    <td style="width:180px !important">
                      <span class="text">{{item.sales_person_name }}</span>
                    </td>
                    <td class="text-right">{{ Number(item.inv_count_id).toLocaleString() }}</td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.inv_amt_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.inv_amt_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">{{ Number(item.crdt_count_id).toLocaleString() }}</td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.crdt_amt_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.crdt_amt_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.without_total_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesPersonFilter',params:{id:item.sales_person_id},query: {name:item.sales_person_name,page:1,show:10,id:item.sales_person_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
                        class="text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.total_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ Number(total_amount.inv_count_id).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.inv_amt_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.inv_amt_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ Number(total_amount.crdt_count_id).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.crdt_amt_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.crdt_amt_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.without_total_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
             <p class="ml-4" v-if="lists.length != 0">Amount is displayed in your base currency <b-badge
                variant="success"
                size="xs"
                style="height:20px"
              >{{orgCurrency}}</b-badge></p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesPerson',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  Model-->
    <b-modal
      :no-close-on-backdrop="true"
      id="salesperson"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      ref="runreport"
      @ok.prevent="selectedfilter={},onRunReport(0)"
    >
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="3">
                <GlobalDateRangePicker
                  class="pl-4"
                  :singleDatePicker="false"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="8" lg="8" md="8" sm="8" xs="8">
              <b-form-group label="Tag List" label-for="taglist" :label-cols="5">
                <b-form-select class="form-control" v-model.trim="sales_tags">
                  <option></option>
                  <option
                    v-for="item in taglist.sales_tags"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />

    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'SalesPersonReports'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
function getPageSalesBySalesPerson(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchSalesPersonLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "SalesPerson",
  components: {
    SaveFilterForm
  },
  mixins: [formatDate, scrollTable],
  data() {
    return {
      psort: this.sort,
      plabel: this.label,
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        "SALES PERSON": "sales_person_name",
        "Inv COUNT": "inv_count_id",
        "Inv WITHOUT TAX": "inv_amt_without_tax",
        "Inv WITH TAX": "inv_amt_with_tax",
        "credit COUNT": "crdt_count_id",
        "credit WITHOUT TAX": "crdt_amt_without_tax",
        " credit WITH TAX": "crdt_amt_with_tax",
        "total WITHOUT TAX": "without_total_balance",
        "total WITH TAX": "total_balance"
      },
      sales_tags: this.$route.query.sales_tags || "",
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      org_name: this.$AppDetails.organization.comp_name || "",
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: ""
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async savefilterform() {
      this.saveforfuture = await {
        from_date: this.from_date,
        to_date: this.to_date,
        label: this.label,
        sort: this.sort,
        sales_tags: this.sales_tags,
        sales_person: this.sales_person,
        show_columns: this.show_columns,
        available_columns: this.available_columns,
        items: this.items
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },

    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchSalesPersonExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,

          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.from_date = filter_content.from_date;
      this.to_date = filter_content.to_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.sales_tags = filter_content.sales_tags;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      if (runreport == 0 && this.$refs.daterangeupdate) {
        var child = this.$refs.daterangeupdate;
        child.checkConsole({
          startDate: this.from_date,
          endDate: this.to_date
        });
      }

      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          sales_tags: this.sales_tags,
          label: $.isEmptyObject(this.selectedfilter)
            ? this.label
            : this.plabel,
          sort: $.isEmptyObject(this.selectedfilter) ? this.sort : this.psort
        }
      });
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    }
  },
  created() {
    // this.from_date = this.$route.query.from_date;
    // this.to_date = this.$route.query.to_date;
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          label: this.label,
          sales_tags: this.sales_tags,
          sort: this.sort
        }
      });
    }
    if (
      typeof this.$route.query.custom != "undefined" &&
      this.$route.query.custom != null
    ) {
      this.from_date = this.$route.query.from_date;
      this.to_date = this.$route.query.to_date;
    }
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("general/fetchtaglist");
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageSalesBySalesPerson(routeTo, next);
  },
  async beforeRouteUpdate(routeTo, routeFrom, next) {
    (await typeof this.$refs.runreport) != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    await getPageSalesBySalesPerson(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      taglist: state => state.general.taglist,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    ...mapGetters(["orgCurrencySymbol","orgCurrency"]),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    }
  }
};
</script>
<!--  Sales by Salesperson style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
</style>